module.exports = require('./helpers/bundle-url').getBundleURL('8kqgc') + "welcome-ilust.da078493.png";